import ComponentLayout from "../../../../src/layouts/component-layout";
import { TestimonialQuoteMarkColors, TestimonialVariants, defaultTestimonialVariant } from '@primer/react-brand';
import { Box as Container, Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  TestimonialQuoteMarkColors,
  TestimonialVariants,
  defaultTestimonialVariant,
  Container,
  Label,
  PropTableValues,
  React
};